import styled from 'styled-components';
import { ImageUtils } from '../../../../utils/ImageUtils';
import { useTextVariant } from '../../../../hook/useTextVariant';
import { ONLINE_INFO_CONSTANTS } from '../../../../constants/onlineInfo';

export const OnlineInfoMobile = () => {
  const { getText } = useTextVariant(ONLINE_INFO_CONSTANTS, true);

  return (
    <Container>
      <Item>
        <TitleContainer>
          <NumberIcon src={ImageUtils.NumberIcon1} />
          <Title>{getText('step1Title')}</Title>
        </TitleContainer>
        <Content>
          <ContentImg1 src={ImageUtils.GuideImg1} />
          <ContentText>{getText('step1Content')}</ContentText>
        </Content>
        <WaringContainer>
          <WaringText>{getText('step1Warning')}</WaringText>
        </WaringContainer>
      </Item>

      <Item>
        <TitleContainer>
          <NumberIcon src={ImageUtils.NumberIcon2} />
          <Title>{getText('step2Title')}</Title>
        </TitleContainer>
        <Content>
          <ContentImg3 src={ImageUtils.GuideImg3} />
          <ContentText>{getText('step2Content')}</ContentText>
        </Content>
        <WaringContainer>
          <WaringText>{getText('step2Warning')}</WaringText>
        </WaringContainer>
      </Item>

      <Item>
        <TitleContainer>
          <NumberIcon src={ImageUtils.NumberIcon3} />
          <Title>{getText('step3Title')}</Title>
        </TitleContainer>
        <Content>
          <ContentImg2 src={ImageUtils.GuideImg2} />
          <ContentTextType2>{getText('step3Content')}</ContentTextType2>
        </Content>
        <WaringContainer>
          <WaringText>{getText('step3Warning1')}</WaringText>
          {/* <WaringText>{getText('step3Warning2')}</WaringText> */}
        </WaringContainer>
      </Item>

      <Item>
        <TitleContainer>
          <NumberIcon src={ImageUtils.NumberIcon4} />
          <Title>{getText('step4Title')}</Title>
        </TitleContainer>
        <Content>
          <ContentImg4 src={ImageUtils.GuideImg4} />
          <ContentText>{getText('step4Content')}</ContentText>
        </Content>
      </Item>
    </Container>
  );
};

const Container = styled.div`
  padding-bottom: 120px;
`;

const Item = styled.div`
  margin-bottom: 13px;
  padding-bottom: 13px;
  border-bottom: 1px solid rgba(112, 112, 112, 0.5);

  &:last-child {
    border-bottom: none;
  }
`;

const TitleContainer = styled.div`
  margin-bottom: 6px;
`;

const Title = styled.h3`
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: -0.32px;
`;

const ContentText = styled.h4`
  color: rgba(255, 255, 255, 0.6);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.32px;
`;

const ContentTextType2 = styled(ContentText)`
  margin-top: 12px;

  span {
    font-weight: 700;
  }

  strong {
    color: #3fb5ff;
  }
`;

const NumberIcon = styled.img`
  width: 18px;
  height: 18px;
  margin-right: 4px;
  float: left;
  margin-top: 1px;
`;

const ContentImg = styled.img`
  margin-right: 9px;
`;

const ContentImg1 = styled(ContentImg)`
  width: 160px;
`;

const ContentImg2 = styled(ContentImg)`
  width: 160px;
`;

const ContentImg3 = styled(ContentImg)`
  width: 160px;
`;

const ContentImg4 = styled(ContentImg)`
  width: 161px;
`;

const Content = styled.div`
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;

const WaringContainer = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  padding-left: 20px;
  margin-top: 6px;
`;

const WaringText = styled.li`
  color: #8e8e8e;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.84px;
  position: relative;

  &:after {
    content: '';
    width: 5px;
    height: 5px;
    background: #8e8e8e;
    border-radius: 50%;
    position: absolute;
    left: -15px;
    top: 50%;
    transform: translateY(-50%);
  }

  strong {
    color: white;
    text-decoration: underline;
  }
`;
